/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { Button } from "primereact/button";

export default function PrimaryButtonPR({
  children,
  onClick,
  type = "submit",
  disabled = false,
  value = null,
  ...props
}) {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled}
      value={value}
      {...props}
    >
      {children}
    </Button>
  );
}
